import { getEffectiveQuantityPrecision, getProduct } from '#/products/domain';

export function normalize(
  productCode: string,
  quantity: number,
  isDated = false,
): string {
  const precision = getEffectiveQuantityPrecision(
    getProduct(productCode),
    isDated,
  );
  const normalizeQty = (qty: number) => qty.toFixed(precision);

  return normalizeQty(quantity);
}
